import React from "react";
import VersionedLegalDocument from "./VersionedLegalDocument";

export default function RussianUserAgreement() {
  return <VersionedLegalDocument documentType="ru_user_agreement" />;
}
